import React from 'react';
import { IconButton } from '@icecreamsocial/components';
import { EmailIcon } from '../SupportedIcons';
import { useIntl } from 'react-intl';

export const EmailButton = ({ ...rest }) => {
	const intl = useIntl();

	/**
	 * localized strings
	 */
	const EMAIL = intl.formatMessage({
		id: 'button.email',
		defaultMessage: 'Email',
		description: 'Text appearing on a button that allows users to send emails.',
	});

	return (
		<IconButton backgroundColor='google' textColor='bodyInverse' {...rest}>
			<IconButton.Icon as={EmailIcon} />
			<IconButton.Text typoSize='1.1em'>{EMAIL}</IconButton.Text>
		</IconButton>
	);
};
